// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import './index.css'; // Tailwind CSS
import App from './App';

// Configuration de dayjs en français
dayjs.locale('fr');

// Thème Ant Design personnalisé
const theme = {
  token: {
    colorPrimary: '#0a6b5a',
    borderRadius: 8,
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    fontSize: 14,
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#0a6b5a',
      headerColor: '#fff',
      headerHeight: 64,
      siderBg: '#1F2937',
    },
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadius: 12,
    },
    Table: {
      borderRadius: 8,
    },
    Input: {
      borderRadius: 8,
    },
    Select: {
      borderRadius: 8,
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={frFR} theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);